{
  "app.title": "ColorGlo Calendar",
  "app.scaffold.heading": "The scaffold is up",
  "app.scaffold.body": "The staff calendar, franchise admin and network dashboard are built in this app (P7–P10).",
  "health.label": "API",
  "health.checking": "Checking …",
  "health.ok": "Reachable",
  "health.unreachable": "Unreachable",
  "nav.calendar": "Calendar",
  "nav.bookings": "Bookings",
  "nav.customers": "Customers",
  "nav.reports": "Reports",
  "nav.settings": "Settings",
  "nav.overview": "Overview",
  "nav.toggle_menu": "Show or hide the menu",
  "nav.more": "More",
  "nav.breadcrumb": "Where you are",
  "nav.account": "Account",
  "nav.impersonating": "You are working as {email}. Everything you do is logged against both accounts.",
  "nav.close": "Close",
  "nav.language": "Language",
  "language.sv": "Svenska",
  "language.no": "Norsk",
  "language.en": "English",
  "nav.theme": "Appearance",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "form.required": "Required",
  "language.da": "Dansk",
  "language.fi": "Suomi"
}
